import { Copy } from '@grubhubprod/gh-cookbook-react';
import { Stack } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { PageHeader } from 'src/components/selfService/layout/PageHeader/PageHeader';
import { PageTitle } from 'src/components/selfService/layout/PageTitle/PageTitle';
import { FeatureFlag } from 'src/types/FeatureFlag';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

export function HomeHeader(): JSX.Element {
  const { user } = useAuth();
  const { isDesktop } = useScreenSizes();
  const { isLoading: isBalanceUiLoading, value: isBalanceUiEnabled } =
    useFeatureFlag(FeatureFlag.ENABLE_BALANCE_UI);

  const title = isBalanceUiEnabled
    ? `Welcome, ${user.first_name}`
    : `Welcome back, ${user.first_name}`;

  const subtitle = isBalanceUiEnabled
    ? 'View credit usage, create and edit meal credits, and start group orders, all from your dashboard.'
    : 'Discover new ways for you and your team to order, and manage your corporate account all in one place.';

  const pageHeaderY = isBalanceUiLoading || !isBalanceUiEnabled ? 'md' : 'sm';

  return (
    <Stack y={isDesktop ? 'lg' : 'md'}>
      <PageHeader y={pageHeaderY}>
        <PageTitle title={title} />
      </PageHeader>
      <Copy variant="body">{subtitle}</Copy>
    </Stack>
  );
}
